export const PING_DELAY = 9 * 60 * 1000; // 9min, because AWS idle every 10 minutes and close the connection
export const RECONNECT_DELAY = 10 * 1000;

export const SOCKET_TOPIC = {
  CHAT: 'CHAT',
  DETAILS: 'DETAILS',
  KANBAN: 'KANBAN',
} as const;

export type SocketTopicEnum = (typeof SOCKET_TOPIC)[keyof typeof SOCKET_TOPIC];

export const SOCKET_ACTION = {
  /** Entities */
  INTERVENTION_UPDATE: 'INTERVENTION_UPDATE',
  AUDIT_CREATED: 'AUDIT_CREATED',
  CONTACT_LIST_UPDATE: 'CONTACT_LIST_UPDATE',
  CONVERSATION_MESSAGE_CREATED: 'CONVERSATION_MESSAGE_CREATED',
  CAMPAIGN_BULK_INTERVENTIONS_CREATED_COMPLETED: 'CAMPAIGN_BULK_INTERVENTIONS_CREATED_COMPLETED',
  CAMPAIGN_BULK_FOLLOW_COMPLETED: 'CAMPAIGN_BULK_FOLLOW_COMPLETED',
  /* Statistics */
  CAMPAIGN_STATS_UPDATE: 'CAMPAIGN_STATS_UPDATE',
  CONTACT_LIST_STATS_UPDATE: 'CONTACT_LIST_STATS_UPDATE',
  /** Conversation */
  MESSAGE_SENT: 'MESSAGE_SENT',
  MESSAGE_NOT_SENT: 'MESSAGE_NOT_SENT',
  MESSAGE_SEEN: 'MESSAGE_SEEN',
  MESSAGE_REACTION_REACT: 'MESSAGE_REACTION_REACT',
  MESSAGE_REACTION_UNREACT: 'MESSAGE_REACTION_UNREACT',
  /** Kiosk */
  KIOSK_STATUS_DETAILS: 'KIOSK_STATUS_DETAILS',
} as const;

export type SocketActionEnum = (typeof SOCKET_ACTION)[keyof typeof SOCKET_ACTION];

export const SOCKET_STATUS = {
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
} as const;

export type SocketStatusEnum = (typeof SOCKET_STATUS)[keyof typeof SOCKET_STATUS];

export const SOCKET_CHECK = 'socket-check';
